import { CarsState } from '../../types';

export const resetEBoxLocations = (state: CarsState) => {
  state.eBoxLocations = { show: true, filter: {} }
};
